import React from 'react'

const TextArea = React.forwardRef((props, ref) => (
  <div className='template-field'>
    <textarea {...props} ref={ref} className='template-control' rows='4'></textarea>
    {props.error && <div className='error_container'>{props.error}</div>}
  </div>
))

export default TextArea
